import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROLE_LABELS } from "../lib/constants";
import { FlaskConical, PlusCircle, ListChecks, MonitorPlay, Users, ScrollText, LogOut, LayoutDashboard } from "lucide-react";

const NAV = [
  { to: "/", label: "Sipariş Girişi", icon: PlusCircle, testid: "nav-order-entry", end: true, page: "order_entry" },
  { to: "/orders", label: "Siparişler", icon: ListChecks, testid: "nav-orders", page: "orders" },
  { to: "/kiosk", label: "Üretim Panosu", icon: MonitorPlay, testid: "nav-kiosk", page: "kiosk" },
  { to: "/dashboard", label: "Yönetim Paneli", icon: LayoutDashboard, testid: "nav-dashboard", page: "dashboard" },
  { to: "/management", label: "Müşteri & Ürün", icon: Users, testid: "nav-management", page: "management" },
  { to: "/audit", label: "İşlem Günlüğü", icon: ScrollText, testid: "nav-audit", page: "audit" },
];

export function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const visibleNav = NAV.filter((n) => (user?.permissions || []).includes(n.page));

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-border bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3">
          <div className="flex items-center gap-2.5">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-lg shadow-primary/30">
              <FlaskConical className="h-5 w-5" />
            </div>
            <div className="leading-tight">
              <div className="font-display text-base font-extrabold tracking-tight">Sipariş Takip</div>
              <div className="text-[11px] text-muted-foreground">Kimyasal Üretim</div>
            </div>
          </div>

          <nav className="ml-6 hidden items-center gap-1 md:flex">
            {visibleNav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={n.testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                    isActive ? "bg-primary/10 text-primary" : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                  }`
                }
              >
                <n.icon className="h-4 w-4" />
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-3">
            <div className="hidden text-right sm:block">
              <div className="text-sm font-semibold leading-tight">{user?.full_name}</div>
              <div className="text-[11px] text-muted-foreground">{ROLE_LABELS[user?.role] || user?.role}</div>
            </div>
            <button
              data-testid="logout-btn"
              onClick={logout}
              className="flex h-9 w-9 items-center justify-center rounded-lg border border-border text-muted-foreground transition-colors hover:bg-destructive hover:text-destructive-foreground"
              title="Çıkış"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>

        {/* mobile nav */}
        <nav className="flex items-center gap-1 overflow-x-auto border-t border-border px-2 py-1.5 md:hidden">
          {visibleNav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`m-${n.testid}`}
              className={({ isActive }) =>
                `flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium ${
                  isActive ? "bg-primary/10 text-primary" : "text-muted-foreground"
                }`
              }
            >
              <n.icon className="h-4 w-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-6">{children}</main>
    </div>
  );
}
